import React, { useState } from "react";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import PlayerDock from "./PlayerDock";
import { Sheet, SheetContent } from "./ui/sheet";
import { NavLink } from "react-router-dom";
import { Home, Compass, LibraryBig, Bookmark, Info } from "lucide-react";

const navItems = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/explore", label: "Explore", icon: Compass },
  { to: "/collections", label: "Collections", icon: LibraryBig },
  { to: "/saved", label: "Saved", icon: Bookmark },
  { to: "/about", label: "About", icon: Info },
];

export default function AppLayout({ children }) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  return (
    <div className="min-h-screen flex" data-testid="app-layout">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar onOpenMobileNav={() => setMobileNavOpen(true)} />
        <main className="flex-1 px-4 sm:px-5 lg:px-10 pt-4 sm:pt-6 pb-40 max-w-[1400px] w-full mx-auto">
          {children}
        </main>
      </div>
      <PlayerDock />

      <Sheet open={mobileNavOpen} onOpenChange={setMobileNavOpen}>
        <SheetContent side="left" className="w-72 bg-[#110d0a] border-r border-white/5 text-paper">
          <div className="pb-6 mb-4 border-b border-white/5">
            <div className="font-display text-2xl text-paper">Majalisul Ilm</div>
            <p className="label-caps mt-2">Circles of Knowledge</p>
          </div>
          {navItems.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              onClick={() => setMobileNavOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 rounded-md text-[15px] mb-1 transition ${
                  isActive ? "text-emerald-soft bg-white/[0.03]" : "text-white/70 hover:text-paper hover:bg-white/[0.03]"
                }`
              }
            >
              <Icon className="w-[18px] h-[18px]" strokeWidth={1.5} /> {label}
            </NavLink>
          ))}
        </SheetContent>
      </Sheet>
    </div>
  );
}
